import { Loader2 } from 'lucide-react';

/*
 * @id     fest.compLoadingScreen
 * @do     afficher_chargement
 * @role   ui
 * @layer  ui
 * @human  Écran de chargement plein écran.
 */
export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Chargement...</p>
      </div>
    </div>
  );
}
